import { useState } from "react";
import { reenviarPorMailService } from "../service/reenviarPorMailService";

export const useReenviarPorMail = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const execute = async (idComprobante) => {
    setLoading(true);
    setError(null);

    try {
      return await reenviarPorMailService(idComprobante);
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return {
    execute,
    loading,
    error,
  };
};
